import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ConfigService } from '../../../core/auth/services/config.service';
import { Observable } from 'rxjs';
import { PagingMaster } from '../../../core/types/helper.model';
import { PaymentResponse } from '../payment-const/payment-model';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

   private httpClient = inject(HttpClient);
  private configService = inject(ConfigService);
  private baseUrl = this.configService.getPatientAPIUrl();
  private apiUrl = this.configService.getAPIUrl(); // v2

   constructor() { }


    getAllPayment(paging?: any):Observable<PagingMaster<PaymentResponse>>{

      return  this.httpClient.get<any>(`${this.apiUrl}/api/GetAllPayments`,{
        params: paging,
      })
    }
    


}
